import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import OpenInNewOutlinedIcon from "@mui/icons-material/OpenInNewOutlined";

/**
 * Ação secundária: abrir em janela dedicada (sem menu/topo), mantendo a tela atual.
 */
export default function OpenInPopupIconButton({
  title,
  ariaLabel,
  onClick,
  disabled = false,
  size = "small",
  stopPropagation = true,
  sx,
}) {
  return (
    <Tooltip title={title}>
      <span>
        <IconButton
          size={size}
          onClick={(e) => {
            if (stopPropagation) e.stopPropagation();
            onClick?.(e);
          }}
          disabled={disabled}
          aria-label={ariaLabel || title}
          sx={{
            border: 1,
            borderColor: "divider",
            borderRadius: 1.5,
            ...sx,
          }}
        >
          <OpenInNewOutlinedIcon sx={{ fontSize: size === "small" ? 18 : 20 }} />
        </IconButton>
      </span>
    </Tooltip>
  );
}
